import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoPostoControleSiad({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'postocontrolesiad', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoPostoControleSiad({ payload }) {
  try {
    const { poco_codigo, params } = payload;

    yield call(api.delete, `postocontrolesiad/${poco_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { poco_codigo, params } = payload;

    yield call(api.post, 'postocontrolesiad', poco_codigo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/postocontrolesiad');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { poco_codigo } = payload;

    const { data } = yield call(api.get, `postocontrolesiad/${poco_codigo}`);

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaopostocontrolesiad, params } = payload;

    yield call(api.put, 'postocontrolesiad', operacaopostocontrolesiad);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/postocontrolesiad');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'postocontrolesiad', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaopostocontrolesiad/OPERACAOABASTECIMENTOS_IN_REQUEST',
    requestOperacaoPostoControleSiad
  ),
  takeLatest(
    '@operacaopostocontrolesiad/DELETE_OPERACAOABASTECIMENTO',
    deleteOperacaoPostoControleSiad
  ),
  takeLatest(
    '@operacaopostocontrolesiad/SUCCESS_REMOVE',
    requestOperacaoPostoControleSiad
  ),
  takeLatest('@operacaopostocontrolesiad/STORE_OPERACAOABASTECIMENTO', store),
  takeLatest('@operacaopostocontrolesiad/FIND_OPERACAOABASTECIMENTO', find),
  takeLatest('@operacaopostocontrolesiad/UPDATE_OPERACAOABASTECIMENTO', update),
  takeLatest('@operacaopostocontrolesiad/RECORD_FILTERING', applyedFilters),
]);
